import * as React from "react";
const SvgFiRrDiploma = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M11 12a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2zm6-3a1 1 0 0 0-1-1H8a1 1 0 0 0 0 2h8a1 1 0 0 0 1-1M8 6h8a1 1 0 1 0 0-2H8a1 1 0 0 0 0 2m12 13.444v3.833a.72.72 0 0 1-1.231.51L18 23.019l-.769.768a.721.721 0 0 1-1.231-.51v-3.833A3.987 3.987 0 0 1 18 12q.509.006 1 .142V5a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h5a1 1 0 0 1 0 2H8a5.006 5.006 0 0 1-5-5V5a5.006 5.006 0 0 1 5-5h8a5.006 5.006 0 0 1 5 5v8.382a3.95 3.95 0 0 1-1 6.062M20 16a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
    />
  </svg>
);
export default SvgFiRrDiploma;
